module.exports = __webpack_public_path__ + "static/media/information-outline.460a96e4.png";